import classnames from 'classnames';
import React from 'react';

import { TextField } from '../material-ui/TextField';
import { useInput } from './hooks/useInput/useInput';
import { useManualInput } from './hooks/useManualInput/useManualInput';
import { useValidate } from './hooks/useValidate/useValidate';
import { useStyles } from './useStyles';

const CustomInput = (props) => {
    const {
        name,
        validator,
        onEditField,
        onBlur,
        label,
        defaultValue,
        value,
        className,
        helperText,
        required,
        type = 'text',
        autoComplete = 'off',
        onFocus,
        shortcuts,
        ...restProps
    } = props;
    const classes = useStyles();
    const { ref, manual, setManual } = useManualInput();
    const { customHelperText, errorText, validate } = useValidate({ validator, helperText, required });
    const { currentValue, handleFocus, handleChange, handleBlur } = useInput({
        defaultValue,
        errorText,
        manual,
        name,
        onBlur,
        onEditField,
        onFocus,
        setManual,
        shortcuts,
        validate,
        value,
    });

    const InputLabelProps = React.useMemo(
        () => ({
            shrink: true,
            ...restProps.InputLabelProps,
        }),
        [restProps.InputLabelProps]
    );

    return (
        <TextField
            {...restProps}
            name={name}
            label={label}
            className={classnames(classes.field, className, name)}
            InputLabelProps={InputLabelProps}
            autoComplete={autoComplete}
            type={type}
            value={currentValue}
            FormHelperTextProps={{
                className: classes.helperText,
            }}
            placeholder={label}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            helperText={customHelperText}
            error={Boolean(errorText)}
            fullWidth={true}
            key={name}
            margin="normal"
            InputProps={{
                inputRef: ref,
            }}
        />
    );
};

const CustomInputMemoized = React.memo(CustomInput);

export { CustomInputMemoized as CustomInput };
